//import libraries
import { Component, OnInit, ViewChild} from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ConfirmationDialogService } from 'src/app/components/general/modals/confirmation/confirmation.service';
import { GeneralService } from 'src/app/services/general.service';
import { CommonUtility } from 'src/app/utility/commonUtility';
import { Router } from '@angular/router';
import { AppFrontRoutes } from 'src/app/constants/app-front-routes';
declare var $: any;
@Component({
  selector: 'app-calendar-add-edit-event',
  templateUrl: './calendar-add-edit-event.component.html',
  styleUrls: ['./calendar-add-edit-event.component.css']
})
export class CalendarAddEditEventComponent implements OnInit {
  readonly AppFrontRoutes = AppFrontRoutes;
  lang:any;
  records:any;
  datatableOptions;
  datatableColsDefs;
  deleteOption: boolean;
  temp;
  datatableCols1: any;
  @ViewChild('treatmentSearch') treatmentSearch;
  constructor(
    private modalService: BsModalService,
    private confirmationDialogService: ConfirmationDialogService,
    private generalService: GeneralService,
    private utility: CommonUtility,
    private router: Router,
  ) { }

  ngOnInit() {

  }




}
